import {CreateFormProps, useCreateForm} from '@/hooks/refinedev/useCreateForm';
import {FormProvider} from 'react-hook-form';

const CreateForm = (props: CreateFormProps) => {
  const {children} = props;
  const useFormResults = useCreateForm(props);
  const {
    handleSubmit,
    refineCore: {onFinish, query},
  } = useFormResults;

  return (
    <FormProvider {...useFormResults}>
      <form onSubmit={handleSubmit(onFinish)} autoComplete="off">
        {children}
      </form>
    </FormProvider>
  );
};

export default CreateForm;
